import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/services/authentication.service';
import { RequestStateService } from './../../core/services/request-state.service';
import { AuthenticationCodeType } from '../../core/model/datos-usuario-cliente';
import { SpecialFormValidators } from '../../core/model/specialFormValidators';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

    form: FormGroup;
    formCode: FormGroup;
    private formSubmitAttempt: Boolean;
    requestError: Boolean;
    requestProcessing: Boolean;
    requestAuthenticationCodeError = false;
    private subscription_auth;

    isLastAttempt = false;

    bodyClasses = 'login';
    body: HTMLBodyElement = document.getElementsByTagName('body')[0];

    username: string;
    password: string;

    showMFA = false;
    textEnterAuthenticationCode: string;
    typeSendMFA: AuthenticationCodeType;

    constructor(
        private fb: FormBuilder,
        private authService: AuthenticationService,
        private router: Router,
        private requestStateService: RequestStateService,
        private translationService: TranslateService
    ) { }

    ngOnInit() {
        if (this.authService.isAuthenticated()) {
            if (this.requestStateService.getLastUnauthorizedUrl()) {
                console.log('Se ha encontrado una url que no pudo cargarse: ' + this.requestStateService.getLastUnauthorizedUrl());
            } else {
                this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
            }
        }
        this.requestProcessing = false;
        this.requestError = false;
        this.form = this.fb.group({ // (5)})
            userName: ['', Validators.required],
            password: ['', Validators.required]
        });

        this.formCode = this.fb.group({
            userCode: ['', [Validators.required, SpecialFormValidators.validateAuthenticationCode]]
        });

        // add the the body classes
        this.body.classList.add('login');
    }

    isFieldInvalid(field: string) {// (6)
        return (
            (!this.form.get(field).valid && this.form.get(field).touched) ||
            (this.form.get(field).untouched && this.formSubmitAttempt)
        );
    }

    firstLogin() {
        if (this.form.valid) {
            this.setRequestUser();

            this.isLastAttempt = false;
            this.subscription_auth = this.authService.firstLogin(this.username, this.password)
                .subscribe(
                    result => {
                        // Tendrá error cuando sea true o undefined, con false es que se ha logado y con valor es que es MFA.
                        if ((result && result !== true) && this.isMFA(result)) {
                            this.translationService.use(result.IDIOMA).subscribe(x => {
                                this.manageMFA(AuthenticationCodeType[AuthenticationCodeType[result.MFA_TYPE]]);
                            });
                            return;
                        }

                        this.showMFA = false;

                        if (result === undefined || result === true) {
                            this.isLastAttempt = result;
                            this.manageErrorLogin();
                            return;
                        }
                        this.requestError = false;
                    },
                    error => {
                        this.manageErrorLogin();
                    }

                );
        }
        this.formSubmitAttempt = true;
    }
    private manageErrorLogin() {
        this.requestError = true;
        this.requestProcessing = false;
    }
    private manageMFA(result: AuthenticationCodeType) {
        this.requestProcessing = false;
        this.typeSendMFA = AuthenticationCodeType[AuthenticationCodeType[result]];
        this.showMFA = true;
        this.requestError = false;
        this.textEnterAuthenticationCode = this.translationService.instant('login.enterAuthenticationCode.'
            + AuthenticationCodeType[this.typeSendMFA]);
    }

    private setRequestUser() {
        this.username = this.form.get('userName').value;
        this.password = this.form.get('password').value;

        this.requestProcessing = true;
    }
    private isMFA(result: any) {
        return result.MFA_TYPE !== undefined && result.IDIOMA;
    }

    returnToLogin() {
        this.showMFA = false;
        this.formCode.get('userCode').setValue('');
    }

    secondLogin() {
        if (this.form.valid && this.formCode.valid) {
            this.setRequestUser();

            this.isLastAttempt = false;
            this.subscription_auth = this.authService.secondLogin(this.username, this.password, this.formCode.get('userCode').value)
                .subscribe(
                    result => {
                        // Si el login ha tenido errores
                        if (result === undefined || result === true) {
                            this.isLastAttempt = result;
                            this.requestAuthenticationCodeError = true;
                            this.requestProcessing = false;
                            return;
                        }

                        this.requestAuthenticationCodeError = false;
                    },
                    error => {
                        this.requestAuthenticationCodeError = true;
                        this.requestProcessing = false;
                        this.returnToLogin();
                    }

                );
        }
        this.formSubmitAttempt = true;
    }

    ngOnDestroy() {
        this.fb = null;
        this.authService = null;
        this.router = null;
        this.subscription_auth = null;
    }


}
